export const navCopy = {
  skip_to_content: "Przeskocz bezpośrednio do głównej zawartości",
  nav_documentation: "Dokumentacja",
  nav_documentation_short: "Dokumentacja",
  nav_download: "Pobierz",
  nav_community: "Społeczność",
  nav_playground: "Wypróbuj",
  nav_playground_short: "Wypróbuj",
  nav_handbook: "Poradnik",
  nav_tools: "Narzędzia",
  nav_search_placeholder: "Szukaj",
  nav_search_aria: "Szukaj na stronie TypeScript",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_version_stable_prefix: "jest już dostępny",
  nav_version_between: ", ",
  nav_version_beta_prefix: "jest aktualnie dostępny w wersji beta.",
  nav_version_rc_prefix: "posiada wersję Release Candidate do wypróbowania.",
  nav_this_page_in_your_lang: "Ta strona jest dostępna w Twoim języku",
  nav_this_page_in_your_lang_open: "Otwórz",
  nav_this_page_in_your_lang_no_more: "Nie pokazuj ponownie",
}
